// todo 1 usage in a file src/client/scripts/customer/middleware/popup-auto-show.middleware.ts:27
export const getCookie = name => {
  const value = '; ' + document.cookie;
  const parts = value.split('; ' + name + '=');
  if (parts.length == 2) {
    var _parts$pop;
    return (_parts$pop = parts.pop()) === null || _parts$pop === void 0 ? void 0 : _parts$pop.split(';').shift();
  }
};